import { Grid, Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuth0 } from '@auth0/auth0-react'
import logo from 'images/farmtrx-logo.png'
import { TEST_IDS } from 'test-ids'

export default function EmailValidation({ email }: { email?: string } = {}) {
  const { t } = useTranslation()
  const { user, logout } = useAuth0()
  const verificationEmail = email || user?.email || ''

  return (
    <Box
      sx={{
        px: 3,
        py: 4,
        display: 'flex',
        maxHeight: '70vh',
        margin: 'auto',
        overflowY: 'auto',
        padding: '2rem',
        maxWidth: '60vw',
        alignItems: 'center',
      }}
      data-testid={TEST_IDS.emailValidationComponent}
    >
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid size={{ xs: 12 }}>
          <img width="160" height="30" src={logo} />
        </Grid>
        <Grid size={{ xs: 12 }}>
          {t('account_email_verify', { email: verificationEmail })}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              window.location.replace(window.location.href.split('?')[0])
            }}
            data-testid={TEST_IDS.emailValidationOkButton}
          >
            {t('ok')}
          </Button>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() =>
              logout({ logoutParams: { returnTo: window.location.origin } })
            }
            data-testid={TEST_IDS.emailValidationLogoutButton}
          >
            {t('logout')}
          </Button>
        </Grid>
        <Grid size={{ xs: 12 }}>
          {t('email')}: {'support@farmtrx.com'}
        </Grid>
      </Grid>
    </Box>
  )
}
